// extracted by mini-css-extract-plugin
export var chartComparison = "style-module--chart-comparison--5b4e3";
export var compare = "style-module--compare--e9e7a";
export var leftTh = "style-module--left-th--7ac14";
export var polarYellow = "style-module--polar-yellow--26c3d";
export var specContainer = "style-module--spec-container--bb3d4";
export var version = "style-module--version--70393";
export var whatsIncluded = "style-module--whats-included--0b8fd";